import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ItemCard from '../ItemCard';
import { getAllTripods } from '../../services/tripodService';

const TripodList = () => {
    const [tripods, setTripods] = useState([]);

    useEffect(() => {
        async function fetchTripods() {
            try {
                const data = await getAllTripods();
                setTripods(data);
            } catch (error) {
                console.error('Error fetching tripods:', error);
            }
        }
        fetchTripods();
    }, []);

    return (
        <div>
            <h1>Tripod List</h1>
            <div className="item-list">
                {tripods.map((tripod) => (
                    <Link to={`/tripods/${tripod.id}`} key={tripod.id}>
                        <ItemCard item={tripod} />
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default TripodList;
